"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let MoleculeGraphCertificate = class MoleculeGraphCertificate extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.baseDim = 200;
        this.baseRadius = this.baseDim / 2;
        this.arrIni = ((2 * 3.141592654 * this.baseRadius) / 12) * 11;
        this.arrFin = 2 * 3.141592654 * this.baseRadius - this.arrIni;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    friendlyCat(cat) {
        return cat.replace(/\+/g, cat[0]);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], MoleculeGraphCertificate.prototype, "score", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MoleculeGraphCertificate.prototype, "category", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MoleculeGraphCertificate.prototype, "category_desc", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MoleculeGraphCertificate.prototype, "theme", void 0);
MoleculeGraphCertificate = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: "MoleculeGraphCertificate",
    })
], MoleculeGraphCertificate);
exports.default = MoleculeGraphCertificate;
